
import { useStats } from '@/hooks/useStats';
import { Widget } from '../Widget';

interface PrayerCountWidgetProps {
  isEditMode?: boolean;
}

export function PrayerCountWidget({ isEditMode }: PrayerCountWidgetProps) {
  const { stats, isLoading } = useStats();

  if (isLoading) {
    return (
      <Widget id="prayer-count" title="Prayer Statistics" isEditMode={isEditMode}>
        <div className="animate-pulse space-y-4">
          <div className="h-16 bg-slate-200 dark:bg-slate-700 rounded" />
          <div className="grid grid-cols-2 gap-3">
            <div className="h-12 bg-slate-200 dark:bg-slate-700 rounded" />
            <div className="h-12 bg-slate-200 dark:bg-slate-700 rounded" />
            <div className="h-12 bg-slate-200 dark:bg-slate-700 rounded" />
            <div className="h-12 bg-slate-200 dark:bg-slate-700 rounded" />
          </div>
        </div>
      </Widget>
    );
  }

  return (
    <Widget id="prayer-count" title="Prayer Statistics" isEditMode={isEditMode}>
      <div className="space-y-4">
        {/* Total prayers - large display */}
        <div className="text-center pb-4 border-b border-slate-200 dark:border-slate-700">
          <div className="text-4xl font-bold text-primary-600 dark:text-primary-400">
            {stats?.prayers.total ?? 0}
          </div>
          <div className="text-sm text-slate-500 dark:text-slate-400 mt-1">
            Total Prayers
          </div>
        </div>

        {/* Status breakdown */}
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-slate-50 dark:bg-slate-900/50 rounded-lg p-3">
            <div className="text-2xl font-semibold text-slate-900 dark:text-white">
              {stats?.prayers.byStatus.pending ?? 0}
            </div>
            <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">
              Pending
            </div>
          </div>
          <div className="bg-slate-50 dark:bg-slate-900/50 rounded-lg p-3">
            <div className="text-2xl font-semibold text-slate-900 dark:text-white">
              {stats?.prayers.byStatus.queued ?? 0}
            </div>
            <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">
              Queued
            </div>
          </div>
          <div className="bg-slate-50 dark:bg-slate-900/50 rounded-lg p-3">
            <div className="text-2xl font-semibold text-slate-900 dark:text-white">
              {stats?.prayers.byStatus.displayed ?? 0}
            </div>
            <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">
              Displayed
            </div>
          </div>
          <div className="bg-slate-50 dark:bg-slate-900/50 rounded-lg p-3">
            <div className="text-2xl font-semibold text-slate-900 dark:text-white">
              {stats?.prayers.byStatus.archived ?? 0}
            </div>
            <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">
              Dismissed
            </div>
          </div>
        </div>
      </div>
    </Widget>
  );
}
